import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import {Check as CheckIcon, Close as CloseIcon} from "@material-ui/icons";
import {apvgkService} from "../../../services/apvgkService";
import {apvgkReportsService} from "../../../services/apvgkReportsService";


const SmevStatus = ({processing, action = false}) => {

    let smev = processing.smev_result;
    const fetchPage = async () =>  {
        apvgkReportsService.checkSmev(processing.id)
            .then(() => {
                smev = {status:1}
            })
            .catch(console.log);

    }
    return (
        <div>
            {smev && ( (smev.status === 2 && smev.rejects && smev.rejects.code === 'NO_DATA') && 'Нет разрешений'
                || (smev.status === 4 && smev.code === "1") && <CheckIcon style={{color: 'green'}}/>
                || smev.exception && "Ошибка"
                || smev.code && (<a href={!smev.xml ? '#' : "/api" + smev.xml} target="_blank">
                    <CloseIcon color={"error"}/>{smev.code && ("Код" + smev.code) || ''} </a>)
                || smev.status === 1 && "Ожидание")
                || ''
            }
            {action && <Link
                color="primary"
                to={{}}
                style={{marginLeft:10}}
                onClick={fetchPage}
            >
                Отправить в СМЭВ
            </Link>}
        </div>
    );
};

export default SmevStatus;
